export const PLATFORM_ID = "6C626154-5065-616C-7466-6F7200000004"; // store website

export const ThemeKeys = {
  TropicalFruit: "921016fe-d34e-4192-beb8-15d775d0ee5b",
  PhoViet: "46565f44-c3e2-449d-8d58-3850a95ffba7",
};

export const PACKAGE_EXPIRED = "PACKAGE_EXPIRED";
